<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_options" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 加载中 -->
            <div class="lite-version-loading-option" v-show="loadingVersions"></div>
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.common.options') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <el-tabs v-model="activeName">
                    <!-- 线程 -->
                    <el-tab-pane :label="$t('language.popup.thread')" name="thread" v-if="false">
                        <div class="lite_tab_content">
                            <div class="thread_item">
                                <span class="thread_item_lable">{{ $t('language.popup.listThread') }}: {{ options.listThread }}</span>
                                <el-slider class="my-slider" :show-tooltip="false" v-model="options.listThread" :step="1" :min="1" :max="5" show-stops></el-slider>
                            </div>
                            <div class="thread_item">
                                <span class="thread_item_lable">{{ $t('language.popup.runThread') }}: {{ options.runThread }}</span>
                                <el-slider class="my-slider" :show-tooltip="false" v-model="options.runThread" :step="1" :min="1" :max="15" show-stops></el-slider>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 同步 -->
                    <el-tab-pane :label="$t('language.popup.syncModes')" name="sync" v-if="options.type == 'sync'">
                        <div class="lite_tab_content">
                            <div class="same_name_desc">{{$t('language.popup.selectSync')}}</div>
                            <!-- 普通同步，实时同步 -->
                            <div class="sync_way_box">
                               <el-switch class="sync_way_switch" v-model="realSync" active-color="#409EFF" inactive-color="#DCDFE6"></el-switch>
                               <span v-if="options.cron==''" class="sync_way">{{ $t('language.cloudSync.normalSync') }}</span>
                               <span v-if="options.cron!=''" class="sync_way">{{ $t('language.cloudSync.realTimeSync') }}</span>
                            </div>
                            <!-- 同步模式 -->
                            <div class="sync_mode_box">
                                <el-radio v-model="options.syncMode" label="one">{{ $t('language.popup.onewaySync') }}</el-radio>
                                <br/>
                                <el-radio v-model="options.syncMode" label="two">{{ $t('language.popup.twowaySync') }}</el-radio>
                            </div>
                            <!-- 单向同步提示 -->
                            <div class="sync_tips" v-if="options.syncMode == 'one'">
                                <b>{{$t('language.popup.tipsFor')}} {{ $t('language.popup.simpleSync') }}</b>
                                <div>{{ $t('language.popup.simpleSyncTip') }}</div>
                            </div>
                            <!-- 双向同步提示 -->
                            <div class="sync_tips" v-if="options.syncMode == 'two'">
                                <b>{{$t('language.popup.tipsFor')}} {{ $t('language.popup.twowaySync') }}</b>
                                <div>{{ $t('language.popup.twowaySyncTip') }}</div>
                            </div>
                            <!-- 特殊字符生成脚本 -->
                            <div class="sync_items">
                                <el-checkbox v-model="options.logFile">
                                    <span>{{$t('language.popup.automaRename')}}</span>
                                    <el-tooltip effect="light" placement="top">
                                        <template slot="content">
                                            <div class="options_tips">{{$t('language.popup.optionsPrompt')}}</div>
                                        </template>
                                        <div class="icon-util question-mark question-mark-position"></div>
                                    </el-tooltip>
                                </el-checkbox>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 传输 -->
                    <el-tab-pane :label="$t('language.cloudTransfer.transfer')" name="tran" v-if="options.type == 'tran'">
                        <div class="lite_tab_content">
                            <div class="same_name_desc">{{$t('language.popup.chooseAction')}}</div>
                            <el-select class="same_name_items" popper-class="same_name_item" size="small" v-model="options.sameName" placeholder=" ">
                                <el-option :label="$t('language.popup.skipFile')" value="skip"></el-option>
                                <el-option :label="$t('language.popup.sourceNewer')" value="timeNew"></el-option>
                                <el-option :label="$t('language.popup.diffSize')" value="sizeDiff"></el-option>
                                <el-option :label="$t('language.popup.sourceAll')" value="timeNew_sizeDiff"></el-option>
                                <el-option :label="$t('language.popup.overWrite')" value="overwrite"></el-option>
                                <el-option :label="$t('language.popup.rename')" value="rename"></el-option>
                            </el-select>
                            <div class="tran_option_items">
                                <div><el-checkbox v-model="options.delete">{{$t('language.popup.deleteAllSource')}}</el-checkbox></div>
                                <div><el-checkbox v-model="options.keepDate">{{$t('language.popup.keepFileDate')}}</el-checkbox></div>
                                <div>
                                    <el-checkbox v-model="options.logFile">
                                        <span>{{$t('language.popup.automaRename')}}</span>
                                        <el-tooltip effect="light" placement="top">
                                            <template slot="content">
                                                <div class="options_tips">{{$t('language.popup.optionsPrompt')}}</div>
                                            </template>
                                            <div class="icon-util question-mark question-mark-position"></div>
                                        </el-tooltip>
                                    </el-checkbox>
                                </div>
                                <div>
                                    <el-checkbox v-model="options.inOneFolder">
                                        <span>{{$t('language.teamTransfer.allTransferred')}}</span>
                                        <el-tooltip effect="light" placement="top">
                                            <template slot="content">
                                                <div class="options_tips">{{$t('language.teamTransfer.optionActivated')}}</div>
                                            </template>
                                            <div class="icon-util question-mark question-mark-position"></div>
                                        </el-tooltip>
                                    </el-checkbox>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 还原 -->
                    <el-tab-pane :label="$t('language.cloudBackup.restore')" name="restore" v-if="options.type == 'restore'">
                        <div class="lite_tab_content">
                            <div class="select-desc">{{$t('language.cloudBackup.selectVersions')}}</div>
                            <el-tooltip effect="light" placement="top">
                                <template slot="content">
                                    <div>{{ restoreTask(options.version) }}</div>
                                </template>
                                <span style="color: #606266;">{{ restoreVersionFormat(options.version) }} {{ '(' + restoreVersionTime(options.version) + ')' }}</span>
                            </el-tooltip>
                            <span v-if="options.version" class="lite_backup_version_details2" @click="loadVersionInfo">
                                <span class="lite_backup_version_details_icon2"></span>
                                <span>{{ $t('language.imageSaver.view') }}</span>
                            </span>
                            <br/>
                            <div class="select-desc">{{$t('language.cloudBackup.restoreOptions')}}</div>
                            <el-select class="same_name_items" popper-class="same_name_item" size="small" v-model="options.sameName" placeholder=" ">
                                <el-option :label="$t('language.cloudBackup.keepLatest')" value=""></el-option>
                                <el-option :label="$t('language.popup.overWrite')" value="overwrite"></el-option>
                                <el-option :label="$t('language.popup.skipFile')" value="skip"></el-option>
                                <el-option :label="$t('language.popup.rename')" value="rename"></el-option>
                            </el-select>
                        </div>
                    </el-tab-pane>
                    <!-- 邮件通知 -->
                    <el-tab-pane :label="$t('language.popup.email')" name="email">
                        <div class="lite_tab_content">
                            <div class="email_desc">
                                <el-checkbox v-model="enableEmail">{{$t('language.popup.sendEmail')}}</el-checkbox>
                            </div>
                            <div class="email_box">
                                <div class="email_mark" v-show="!enableEmail"></div>
                                <el-input size="small" class="email_input" @focus="onEmailFocus" v-model="options.email" placeholder="Email"></el-input>
                                <button class="email_test" @click="sendEmail()">{{$t('language.popup.sendMessage')}}</button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 过滤 -->
                    <el-tab-pane name="filter">
                        <span slot="label">
                            <span>{{ $t('language.popup.filter') }}</span>
                            <span class="lite_vip_icon"></span>
                        </span>
                        <div class="lite_tab_content">
                            <!-- 包含扩展名 -->
                            <div class="tag_desc">{{ $t('language.popup.filterInclude') }}</div>
                            <div class="tag_box myscroll">
                                <el-tag :key="tag" v-for="tag in options.allowedExtensions" closable :disable-transitions="false"
                                    color="#5562b430" effect="plain" type="info"
                                    @close="handleCloseIncluded(tag)">
                                    {{ tag }}
                                </el-tag>
                                <el-input class="input-new-tag" v-if="inputVisibleIncluded" v-model="inputValueIncluded"
                                    ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirmIncluded"
                                    @blur="handleInputConfirmIncluded">
                                </el-input>
                                <button v-else class="button-new-tag" size="small" @click="showInputIncluded">+ {{ $t('language.popup.newFilterTag') }}</button>
                            </div>
                            <!-- 排除文件名 -->
                            <div class="tag_desc">{{ $t('language.popup.filterExclude') }}</div>
                            <div class="tag_box myscroll">
                                <el-tag :key="tag" v-for="tag in options.excludeNames" closable :disable-transitions="false"
                                    color="#5562b430" effect="plain" type="info"
                                    @close="handleCloseExclude(tag)">
                                    {{ tag }}
                                </el-tag>
                                <el-input class="input-new-tag" v-if="inputVisibleExclude" v-model="inputValueExclude"
                                    ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirmExclude"
                                    @blur="handleInputConfirmExclude">
                                </el-input>
                                <button v-else class="button-new-tag" size="small" @click="showInputExclude">+ {{ $t('language.popup.newFilterTag') }}</button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 底部 -->
             <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="close()" class="white">{{ $t('language.common.cancel') }}</button>
                <button @click="ok()">{{ $t('language.common.save') }}</button>
            </div>
            <!-- 已备份某版本文件列表 -->
            <liteBackupFiles ref="backupFiles" :files="versionFiles" />
        </div>
    </div>
</template>

<script>
import liteBackupFiles from "@/components/workspace/lite_backup_files";
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import { Message } from "element-ui";

export default {
    props: {
        data: Object,
    },
    components: {
        liteBackupFiles,
    },
    computed: {
        realSync: {
            get() {
                return this.options.cron != ''
            },
            set(val) {
                this.options.cron = val ? '0 */5 * * * ?' : '' ;
            }
        }
    },
    watch: {
        enableEmail(val) {
            if (val && this.options.email=='') {
                const user = commonUtils.getUser();
                this.options.email = user.email;
            }
        }
    },
    data() {
        return {
            enableEmail: false,
            show: false,
            activeName: this.defaultActiveTab(),
            options: {
                listThread: 1,
                runThread: 1,
                email: '',
                cron: '',
                sameName: '',
                excludeNames: [],
                allowedExtensions: [],
                type: '',
                onlyAdd: false,
                schedules: {disabled:true},
                delete: false,
                keepDate: false,
                logFile: false,
                inOneFolder: false,
                syncMode: '',
                version: '',
            },
            inputVisibleIncluded: false,
            inputValueIncluded: '',
            inputVisibleExclude: false,
            inputValueExclude: '',
            // 是否正在加载版本
            loadingVersions: false,
            // 版本具体文件信息
            versionFiles: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        loadVersionInfo() {
            this.loadingVersions = true;
            this.sendRequest('/task/versionInfo', { id: this.restoreVersionTid(this.options.version), version: this.restoreVersionTime(this.options.version) }, (res) => {
                this.versionFiles = res;
                this.loadingVersions = false;
                if (this.versionFiles.length > 0) {
                    this.$refs.backupFiles.show = true;
                } else {
                    Message.warning("No files found in this version");
                }
            }, () => {
                this.loadingVersions = false;
            });
        },
        // 获取
        getTask(taskId) {
            return this.$store.state.tasks.find(task => task.id === taskId) || null;
        },
        // 还原的任务
        restoreTask(task_version) {
            let index = task_version.indexOf('-');
            let tid = task_version.substring(0, index);
            let task = this.getTask(tid);
            return task ? task.name : 'Task does not exist.';
        },
        // 还原的版本
        restoreVersionFormat(task_version) {
            let time = this.restoreVersionTime(task_version);
            return this.formatDate(parseInt(time));
        },
        // 还原的版本时间戳
        restoreVersionTime(task_version) {
            let index = task_version.indexOf('-');
            return task_version.substring(index + 1);
        },
        // 备份版本任务ID
        restoreVersionTid(task_version) {
            let index = task_version.indexOf('-');
            return task_version.substring(0, index);
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        onEmailFocus() {
            if (!this.options.email) {
                const user = commonUtils.getUser();
                this.options.email = user.email;
            }
        },
        checkEmail() {
            if (this.options.email) {
                if (!commonstate.emailpattern.test(this.options.email)) {
                    Message.warning(this.$t('language.login.enterCorrectEmai'));
                    return false;
                }
            }
            return true;
        },
        sendEmail() {
            if (this.options.email) {
                if (!this.checkEmail()) return;
                let emailData = {
                    email: this.options.email,
                    ud: commonUtils.getUser().id
                }
                this.Utils.doEmailRequest("send_test_msg", emailData).then(res => {
                    if (res.status == 200) {
                        Message.success(this.$t('language.meassage.emailSend'));
                    } else {
                        Message.error(this.$t('language.exception.' + res.reason));
                    }
                });
            }
        },
        isVip() {
            const user = commonUtils.getUser();
            return user.vip;
        },
        defaultActiveTab() {
            if (this.options) {
                if (this.options.type == 'tran') {
                    return 'tran';
                } else if (this.options.type == 'sync') {
                    return 'sync';
                } else {
                    return 'email';
                }
            }
        },
        showUpgrad() {
            var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
            upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_filter');
            upgradeNewDialog.curItem = 'filter';
            upgradeNewDialog.isShow = true;
            this.show = false
        },
        ok() {
            if (!this.checkEmail()) return;
            if (!this.isVip()) {
                if (this.options.excludeNames.length>0 || this.options.allowedExtensions.length>0) {
                    this.showUpgrad();
                    return;
                }
            }
            if (this.enableEmail && this.options.email=='') {
                Message.warning('Please enter the notification email address.');
                return;
            }
            if (!this.enableEmail) {
                this.options.email = '';
            }
            this.$emit('ok', this.options);
            this.show = false;
            this.activeName = this.defaultActiveTab();
        },
        init() {
            this.activeName = this.defaultActiveTab();
            var options = {};
            options.listThread = this.data.listThread;
            options.runThread = this.data.runThread;
            options.email = this.data.email;
            options.cron = this.data.cron;
            options.sameName = this.data.sameName;
            options.version = this.data.version;
            options.excludeNames = [];
            options.allowedExtensions = [];
            options.excludeNames.push(...this.data.excludeNames);
            options.allowedExtensions.push(...this.data.allowedExtensions);
            options.type = this.data.type;
            options.onlyAdd = this.data.onlyAdd;
            options.schedules = this.data.schedules;
            options.delete = this.data.delete;
            options.keepDate = this.data.keepDate;
            options.logFile = this.data.logFile;
            options.inOneFolder = this.data.inOneFolder;
            options.syncMode = this.data.syncMode;
            this.options = options;
            this.enableEmail = this.data.email!='';
        },
        close() {
            if (!this.enableEmail) {
                this.options.email = '';
            }
            this.init();
            this.show = false;
        },
        handleCloseIncluded(tag) {
            this.options.allowedExtensions.splice(this.options.allowedExtensions.indexOf(tag), 1);
        },
        showInputIncluded() {
            this.inputVisibleIncluded = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirmIncluded() {
            let inputValueIncluded = this.inputValueIncluded;
            if (inputValueIncluded) {
                const ext = inputValueIncluded.replace(/^\./, '').toLowerCase();
                this.options.allowedExtensions.push(ext);
            }
            this.inputVisibleIncluded = false;
            this.inputValueIncluded = '';
        },
        handleCloseExclude(tag) {
            this.options.excludeNames.splice(this.options.excludeNames.indexOf(tag), 1);
        },
        showInputExclude() {
            this.inputVisibleExclude = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirmExclude() {
            let inputValueExclude = this.inputValueExclude;
            if (inputValueExclude) {
                this.options.excludeNames.push(inputValueExclude);
            }
            this.inputVisibleExclude = false;
            this.inputValueExclude = '';
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data);
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg);
                            if (errCallback) {
                                errCallback()
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err);
                    if (errCallback) {
                        errCallback()
                    }
                });
        }
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box {
    width: 678px;
}

/* 弹窗内容高度 */
.lite_options .lite_popup_content {
    height: 300px;
}

/* tab内容 */
.lite_tab_content {
    padding-top: 20px;
}

/* 线程项 */
.thread_item {
    margin: 0 12px;
}

/* 文字描述 */
.same_name_desc,
.thread_item_lable,
.email_desc,
.tag_desc {
    font-size: 14px;
    color: #6f7886;
}

/* 所有标签 */
.tag_box {
    margin-bottom: 30px;
    height: 85px;
    overflow: auto;
}

/* 标签项 */
.tag_box .el-tag {
    margin-top: 10px;
    margin-right: 10px;
    max-width: 200px;
    padding-right: 25px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
}

.tag_box .el-tag__close {
    position: absolute;
    z-index: 1;
    right: 5px;
    top: 7px;
}

/* 新增标签按钮 */
.button-new-tag {
    margin-top: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    position: relative;
    top: 1px;
    vertical-align: middle;
}

/* 新增标签输入框 */
.input-new-tag {
    width: 90px;
    margin-bottom: 1px;
    vertical-align: middle;
}

/* 滑块样式，条形 */
.my-slider .el-slider__bar {
  background-color: #5562B4;
}

/* 滑块样式，圆形 */
.my-slider .el-slider__button {
  border-color: #5562B4;
}

.email_input {
    width: 300px !important;
}

.email_test {
    margin-left: 10px;
    position: relative;
    top: 1px;
}

.lite_vip_icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -1px;
    width: 20px;
    height: 20px;
    background-image: url('../../assets/images/lite/icon/vip.svg');
}

.email_box {
    position: relative;
}
.email_mark {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
}
.same_name_items {
    width: 300px;
}
.same_name_items .el-input__suffix {
    height: 32px;
    top: 10px;
}
.same_name_item .el-select-dropdown__item {
    color: #6f7886;
    font-size: 12px;
}
.same_name_item .el-select-dropdown__item.selected {
    color: #6f7886;
}
.el-select .el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner {
    border-color: #5562B4;
}

.tran_option_items {
    margin-top: 40px;
}
.tran_option_items>div {
    font-size: 14px;
    color: #6f7886;
    margin: 12px 0px;
}
.sync_items .el-checkbox__input.is-checked+.el-checkbox__label,
.tran_option_items .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266;
}
.options_tips {
    width: 400px;
    font-size: 12px;
    color: #6f7886;
}
.sync_items {
    margin-top: 6px;
}
.sync_tips {
    margin-top: 20px;
}
.sync_tips>b {
    font-size: 14px;
    color: #323b4c;
}
.sync_tips>div {
    margin-top: 10px;
    font-size: 14px;
    color: #6f7886;
    line-height: 25px;
}
.sync_way_box {
    margin-top: 10px;
    margin-bottom: 2px;
}
.sync_way {
    color: #6f7886;
    font-size: 13px;
    margin-left: 6px;
}
.sync_way_switch .el-switch__core {
    height: 14px;
    width: 24px !important;
}
.sync_way_switch .el-switch__core::after {
    height: 10px;
    width: 10px;
}
.sync_way_switch.el-switch.is-checked .el-switch__core::after {
    left: 27px;
}
.sync_mode_box>.el-radio {
    margin-top: 10px;
}
/* 加载备份版本信息 */
.lite-version-loading-option {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 40px;
    width: 100%;
    height: calc(100% - 40px);
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.lite-version-loading-option::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
/* 显示版本信息 */
.lite_backup_version_details2 {
    margin-left: 20px;
    cursor: pointer;
    color: #5562B4;
}
.lite_backup_version_details2:hover {
    text-decoration: underline;
}
.lite_backup_version_details_icon2 {
    background-image: url("../../assets/images/vectorImg/icon_Preview.svg");
    width: 16px;
    height: 16px;
    display: inline-block;
    position: relative;
    top: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_options.vue